import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimprichichwadonlinecabbooking() {



  const cardData =
  {
    keyword: 'Pimpri Chinchwad Online Cab Booking',
    heading: 'Sai Trupti Cabs: Pimpri Chinchwad Online Cab Booking',
    headingDescription: 'Sai Trupti Cabs offers convenient and efficient Pimpri Chinchwad online cab booking services, designed to make your city rides and out-station journeys smooth and stress-free. Our fleet of well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles are all equipped with clean interiors and ample luggage space. Every trip is managed by a professional, background-verified chauffeur who ensures punctual pickup in Pimpri Chinchwad, courteous service, and safe, smooth driving throughout your ride. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your online cab booking in Pimpri Chinchwad convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
  {
    "name": "Pimpri Chinchwad Online Cab Booking",
    "description": "Book cabs online in Pimpri Chinchwad (PCMC) with instant confirmation, flexible scheduling, and multiple vehicle options including sedans, SUVs, and luxury cars. Enjoy AC/non-AC rides, professional drivers, transparent fares, and 24x7 availability for both local and outstation travel."
  },
  {
    "name": "PCMC Cab Booking",
    "description": "Reliable PCMC cab booking service offering quick online reservations, affordable rates, AC/non-AC options, and professional chauffeurs. Ideal for daily commutes, airport transfers, business trips, and weekend getaways with real-time support and safe travel assurance."
  },
  {
    "name": "Pimpri Chinchwad Taxi Service",
    "description": "Book trusted taxi services in Pimpri Chinchwad for local, one-way, or outstation trips. Choose from hatchbacks, sedans, or SUVs with experienced drivers, flexible pickup and drop options, and transparent fares for a comfortable and secure journey."
  },
  {
    "name": "Pimpri Chinchwad Car Hire",
    "description": "Affordable car hire service in Pimpri Chinchwad providing AC/non-AC cars with professional chauffeurs. Perfect for business meetings, airport drops, family outings, and outstation travel with clean vehicles and timely pickups."
  },
  {
    "name": "AC Cab PCMC",
    "description": "Enjoy a cool and comfortable ride in Pimpri Chinchwad with AC cab rentals. Equipped with professional drivers, clean interiors, flexible pickup/drop points, and budget-friendly fares ideal for daily commutes and long-distance trips."
  },
  {
    "name": "Non AC Cab PCMC",
    "description": "Budget-friendly non-AC cab service in PCMC offering affordable transportation for short and long-distance travel. Reliable drivers, clean cars, and punctual service make it an excellent choice for cost-effective travel within Pimpri Chinchwad."
  },
  {
    "name": "Luxury Cab PCMC",
    "description": "Experience premium travel in Pimpri Chinchwad with luxury cab rentals featuring high-end sedans and SUVs. Ideal for VIP guests, weddings, corporate events, and airport transfers with professional chauffeurs and top-notch comfort."
  },
  {
    "name": "Pimpri Chinchwad Cab Near Me",
    "description": "Find nearby cabs instantly in Pimpri Chinchwad with our on-demand cab service. Quick booking, verified drivers, AC/non-AC options, and real-time tracking ensure safe, comfortable, and timely transportation anywhere in PCMC."
  },
  {
    "name": "Affordable Cab PCMC",
    "description": "Pocket-friendly cab booking in PCMC offering transparent pricing, reliable drivers, AC/non-AC options, and clean vehicles. Perfect for everyday travel, office commutes, and local errands with guaranteed on-time service."
  },
  {
    "name": "Corporate Cab Hire PCMC",
    "description": "Professional corporate cab hire in Pimpri Chinchwad offering executive sedans, SUVs, and luxury vehicles. Includes AC/non-AC options, trained chauffeurs, real-time tracking, and flexible billing suitable for meetings, conferences, and office travel."
  },
  {
    "name": "Wedding Cab PCMC",
    "description": "Book stylish wedding cabs in Pimpri Chinchwad with decorated vehicles, experienced drivers, and punctual service. Choose from luxury sedans, SUVs, or AC cars to ensure smooth and elegant wedding transportation for guests and families."
  },
  {
    "name": "Pimpri Chinchwad Outstation Cab",
    "description": "Hire outstation cabs from Pimpri Chinchwad for long-distance travel to Mumbai, Nashik, Mahabaleshwar, and more. Choose from AC/non-AC vehicles, professional drivers, and affordable packages designed for comfort, safety, and reliability."
  },
  {
    "name": "Online Taxi Booking Pimpri Chinchwad",
    "description": "Book taxis online in Pimpri Chinchwad for instant confirmation and hassle-free travel. Select from a variety of cars—sedans, hatchbacks, or SUVs—with AC/non-AC options, flexible routes, and professional drivers available round the clock."
  },
  {
    "name": "Best Cab Service PCMC",
    "description": "Top-rated cab service in PCMC providing safe, reliable, and comfortable rides. Well-maintained vehicles, professional chauffeurs, transparent pricing, and flexible booking options make it the preferred choice for both local and outstation trips."
  },
  {
    "name": "Cab Service 24x7 Pimpri Chinchwad",
    "description": "24x7 cab service in Pimpri Chinchwad offering round-the-clock availability for emergencies, airport transfers, and business travel. AC/non-AC options, skilled drivers, real-time tracking, and quick response ensure convenient and safe travel anytime."
  }
],
"tableData": [
  ["Pimpri Chinchwad Online Cab Booking", "PCMC Cab Booking"],
  ["Pimpri Chinchwad Taxi Service", "Pimpri Chinchwad Car Hire"],
  ["AC Cab PCMC", "Non AC Cab PCMC"],
  ["Luxury Cab PCMC", "Pimpri Chinchwad Cab Near Me"],
  ["Affordable Cab PCMC", "Corporate Cab Hire PCMC"],
  ["Wedding Cab PCMC", "Pimpri Chinchwad Outstation Cab"],
  ["Online Taxi Booking Pimpri Chinchwad", "Best Cab Service PCMC"],
  ["Cab Service 24x7 Pimpri Chinchwad", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pimpri Chinchwad Online Cab Booking",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers seamless online booking for cab services throughout Pimpri Chinchwad — ideal for city pickups, airport transfers, one‑way drops and outstation rides."
  },
  {
    "WhyChooseheading": "Instant Booking & Confirmation",
    "WhyChoosedescription": "Use our website or WhatsApp to book your cab from Pimpri Chinchwad in just a few clicks—enter pickup/drop‑off, select vehicle type, pay online (or later) and receive instant confirmation. :contentReference[oaicite:turn0search1]{index=1} :contentReference[oaicite:turn0search6]{index=1}"
  },
  {
    "WhyChooseheading": "Transparent & Competitive Rates",
    "WhyChoosedescription": "Enjoy clear pricing for online bookings from Pimpri Chinchwad—starting from as low as ₹706 for short drops and ~₹13.5/km for longer routes. :contentReference[oaicite:turn0search0]{index=1} :contentReference[oaicite:turn0search3]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo‑travellers or luxury cars through our online portal, matching your group size, luggage and travel plan. :contentReference[oaicite:turn0search8]{index=1}"
  },
  {
    "WhyChooseheading": "Professional & Punctual Drivers",
    "WhyChoosedescription": "Our experienced drivers are verified, trained and familiar with routes from and around Pimpri Chinchwad—ensuring smooth and timely pickups and drops."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "Book pickups from any location in Pimpri Chinchwad (city, airport or suburbs) and drops to anywhere (city, station, hotels or out‑station)—all via the same online panel."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All vehicles booked online come with proper sanitation, regular service checks and are equipped for comfort and reliability throughout your ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our online booking system is backed with round‑the‑clock support via phone/WhatsApp—ready to assist you anytime with trips, cancellations, changes or queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free-Cancellation & Payment Options",
    "WhyChoosedescription": "With online booking, you get multiple payment options (online, UPI, card or cash) and simple cancellation/modification terms — so you're covered for unexpected changes."
  }
]


















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer online cab bookings in Pimpri Chinchwad?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable online cab bookings in Pimpri Chinchwad for local trips, one-way drops, return trips, and outstation travel.',
  },
  {
    question: 'How can I book a cab online in Pimpri Chinchwad with Sai Trupti Cabs?',
    answer: 'You can book your cab in Pimpri Chinchwad easily through our website or mobile app, or by contacting our 24×7 customer support team—select your pick-up time, vehicle type and make secure payment online.',
  },
  {
    question: 'What cab types are available for online booking in Pimpri Chinchwad?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta and tempo-travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for online cab trips booked in Pimpri Chinchwad?',
    answer: 'Yes, all our drivers are professional, courteous and trained for long as well as short-distance trips—ensuring a safe and comfortable journey from Pimpri Chinchwad.',
  },
  {
    question: 'Can I book an online cab from Pimpri Chinchwad for corporate, airport or outstation travel?',
    answer: 'Certainly. Our online booking services in Pimpri Chinchwad cater to airport transfers, corporate travel, sightseeing tours, one-way and round-trip outstation journeys.',
  },
  {
    question: 'Is the online cab booking service in Pimpri Chinchwad available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 online booking for cabs in Pimpri Chinchwad so you can schedule your ride any time for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the online cab booking fares in Pimpri Chinchwad?',
    answer: 'Our online cab fares in Pimpri Chinchwad start from approximately ₹500-₹700 for short local drops, and for longer routes the fare depends on vehicle type, distance and travel time. For example, some online platforms list one-way cabs in the Pimpri-Chinchwad to Pune route starting from around ₹700. :contentReference[oaicite:1]{index=1}',
  },
  {
    question: 'What payment methods are accepted for online cab bookings in Pimpri Chinchwad?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets and bank transfers for seamless online booking and payment.',
  },
  {
    question: 'What safety and hygiene protocols are followed for cabs booked online in Pimpri Chinchwad?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure a secure journey from the moment you book online.',
  },
  {
    question: 'Is customer support available during online cab trips booked in Pimpri Chinchwad?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during and after your online-cab journey in Pimpri Chinchwad.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kiran More',
    feedback: 'Booking online with Sai Trupti Cabs in Pimpri Chinchwad was effortless. Car came on time and the driver was professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah',
    feedback: 'Excellent online cab service in Pimpri Chinchwad from Sai Trupti Cabs. The app/website booking made it easy and the ride was smooth.',
    rating: 5,
  },
];



















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimpri Chinchwad Online Cab Booking",
  "image": "https://saitrupticabs.com/assets/images/pcmc-cab.jpg",
  "description": "Book online cab services in Pimpri Chinchwad (PCMC) for local, outstation, corporate, or wedding travel. AC and Non-AC cabs available, affordable and reliable 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6240"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pimpri-chinchwad-online-cab-booking"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pimpri Chinchwad Online Cab Booking | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book online cab services in Pimpri Chinchwad (PCMC) for local, outstation, corporate, or wedding travel. AC and Non-AC cabs available, affordable and reliable 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pimpri Chinchwad Online Cab Booking, PCMC Cab Booking, Pimpri Chinchwad Taxi Service, Pimpri Chinchwad Car Hire, AC Cab PCMC, Non AC Cab PCMC, Luxury Cab PCMC, Pimpri Chinchwad Cab Near Me, Affordable Cab PCMC, Corporate Cab Hire PCMC, Wedding Cab PCMC, Pimpri Chinchwad Outstation Cab, Online Taxi Booking Pimpri Chinchwad, Best Cab Service PCMC, Cab Service 24x7 Pimpri Chinchwad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimprichichwadonlinecabbooking;